import { useState } from "react";
//#region Styles
import { Container } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import DialogSearchCampus from "../DialogSearchCampus/DialogSearchCampus";
//#endregion
//#region Images
//#endregion
//#region Services
import { requestCreateUser, requestUpdateUser } from "services/settings/roleAdmin/aboutRoleAdmin";
//#endregion
//#region Utils
import { errorFree } from "utils/validations";
import { 
    ERROR_TEXT_DICTIONARY, 
    ERROR_TEXT_LIST, 
    USER_ROLES_NEED_CAMPUS } from "../../utils/constants";
import useMainContext from "utils/context/useMainContext";
import useNewUserAddedOrUpdated from "../../utils/hooks/useNewUserAddedOrUpdated";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const Footer = ({
    isCreate,
    currentUser,
    formData: {
        form, 
        errors,
        errorText
    },
    closeForm,
    loadingRequest,
    userList,
    data: {
        campusList
    },
}) => {
    const mainContext = useMainContext();
    //#region States
    const [fieldToUpdate, setFieldToUpdate] = useState({
        field: "",
        article: "",
        newValue: ""
    });
    const [campusForRoleAssignment, setCampusForRoleAssignment] = useState({
        id: 0,
        name: ""
    });
    const [showDialogSearchCampus, setShowDialogSearchCampus] = useState(false);
    //#endregion
    //#region Custom hooks
    const newUser = useNewUserAddedOrUpdated({
        userList
    });
    const dialogShowSaveChanges = useShowDialogAlert();
    //#endregion
    //#region Effects
    //#endregion
    //#region Functions
    const toggleShowDialogSearchCampus = (value = null) => {
        const tempForm = { ...form.value };

        setShowDialogSearchCampus(value !== null ? value : !showDialogSearchCampus);
        
        setFieldToUpdate(tempForm.fieldToUpdate);
    }
    const assignRoleOrUpdateUser = async () => {
        const params = isCreate 
            ? {
                request: async () => await requestCreateUser({
                    ...form.value,
                    campusId: campusForRoleAssignment.id
                }),
                loadingRequestMessage: "Asignando nuevo rol...",
                toast: "¡Se asignó exitosamente el nuevo Rol!"
            }
            : {
                request: async () => await requestUpdateUser({
                    ...form.value,
                    campusId: campusForRoleAssignment.id
                }),
                loadingRequestMessage: "Actualizando información...",
                toast: fieldToUpdate 
                    ? `¡Se guardó exitosamente el cambio de ${fieldToUpdate.field}!`
                    : `¡Se guardaron exitosamente los cambios!`
            };
        loadingRequest.show(params.loadingRequestMessage);
        const result = await params.request();
        // Resolviendo respuesta
        if (result.success) {
            // Exitosa
            await userList.fill(result.toast);
            // Setteando información del nuevo usuario
            newUser.set({
                value: result.newUser,
                changes: result.changes
            });
            closeForm();
            return;
        }
        // Fallida
        loadingRequest.hide();
        if (!result.message) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        dialogShowSaveChanges.set(false);
        errorText.set(ERROR_TEXT_DICTIONARY[result.message]);
        const newErrors = {
            ...errors.value
        };
        if (result.message === ERROR_TEXT_LIST.NAMES_ALREADY_REGISTERED) {
            errors.set({
                ...newErrors,
                name: true,
                surname: true
            });
            return;
        }
        if ([
            ERROR_TEXT_LIST.USER_ALREADY_REGISTERED, 
            ERROR_TEXT_LIST.USER_NOT_EXISTS
        ].includes(result.message)) {
            errors.set({
                ...newErrors,
                user: true
            });
        }
    }
    const doAssignRoleOrUpdateUser = async () => {
        try {
            await assignRoleOrUpdateUser();
        }
        catch (err) {
            setCampusForRoleAssignment({ id: 0, name: "" });
            loadingRequest.hide();
            mainContext.setShowDialogUnexpectedError(true);
        }
    }
    const checkIfThereAreMoreThanTwoChanges = quantityChanges => {
        quantityChanges++;
        if (quantityChanges > 1) 
            throw new Error();
        return quantityChanges;
    }
    const isValidForm = () => {
        const { user, name, surname, category, role } = form.value;
        const newErrors = {
            user: !Boolean(user),
            name: !Boolean(name),
            surname: !Boolean(surname),
            category: !Boolean(category.id),
            role: !Boolean(role.id)
        };
        errors.set(newErrors);
        if (!errorFree(newErrors)) {
            errorText.set(ERROR_TEXT_DICTIONARY.FORMULARIO_INCOMPLETO);
            return false;
        };
        return true;
    }
    const changeCampusForRoleAssignment = value => {
        setCampusForRoleAssignment(value);
        dialogShowSaveChanges.set(true);
    }
    const roleNeedsCampus = () => {
        return USER_ROLES_NEED_CAMPUS.includes(form.value.role.id);
    }
    const openDialogSaveChanges = () => {
        if (!isValidForm()) 
            return;
        if (roleNeedsCampus()) {
            toggleShowDialogSearchCampus(true);
            return;
        }
        // Abriendo modal de confirmación de guardado de cambios
        dialogShowSaveChanges.set(true);
        const currentForm = form.value;
        
        try {
            // Obteniendo información sobre el / los campo(s) a modificar
            let quantityChanges = 0;
            let newFieldToUpdate = null;
            if (currentForm.name !== currentUser.name) {
                newFieldToUpdate = {
                    field: "Nombre",
                    article: "el",
                    newValue: currentForm.name
                };
                quantityChanges = checkIfThereAreMoreThanTwoChanges(quantityChanges);
            }
            if (currentForm.surname !== currentUser.surname) {
                newFieldToUpdate = {
                    field: "Apellido",
                    article: "el",
                    newValue: currentForm.surname
                };
                quantityChanges = checkIfThereAreMoreThanTwoChanges(quantityChanges);
            }
            if (currentForm.category.id !== currentUser.category.id) {
                newFieldToUpdate = {
                    field: "Categoría",
                    article: "la",
                    newValue: currentForm.category.name
                };
                quantityChanges = checkIfThereAreMoreThanTwoChanges(quantityChanges);
            }
            if (currentForm.role.id !== currentUser.role.id) {
                newFieldToUpdate = {
                    field: "Rol",
                    article: "el",
                    newValue: currentForm.role.name
                };
                quantityChanges = checkIfThereAreMoreThanTwoChanges(quantityChanges);
            }
            setFieldToUpdate(newFieldToUpdate);
        }
        catch (err) {
            setFieldToUpdate(null);
        }
    }
    const areThereChanges = () => {
        if (!currentUser) return true;
        const currentForm = form.value;
        return (
            currentForm.name !== currentUser.name ||
            currentForm.surname !== currentUser.surname || 
            currentForm.category.id !== currentUser.category.id ||
            currentForm.role.id !== currentUser.role.id
        );
    }
    const getDialogAlertActionProps = () => {
        if (isCreate) {
            if (form.value.role.id === roleNeedsCampus()) {
                const { user } = form.value;
                return {
                    title: `¿Deseas asignar a ${user} como bibliotecario del campus ${campusForRoleAssignment.name}?`,
                    contentComponent: (
                        <p className="paragraph center">
                            Recuerda que el usuario {user} solo podrá visualizar las reservas de las bibliotecas de dicho campus.
                        </p>
                    )
                };
            }
            return {
                title: "¿Deseas asignar este rol al nuevo usuario?",
                contentComponent: (
                    <p className="paragraph">
                        Recuerda que podrás visualizar el nuevo usuario en la página principal.
                    </p>
                )
            };
        }
        if (fieldToUpdate)
            return {
                title: `¿Deseas cambiar el campo de ${fieldToUpdate.field}?`,
                contentComponent: (
                    <p className="paragraph">
                        Recuerda que ahora {fieldToUpdate.article} {fieldToUpdate.field} de <b>{form.value.user}</b> será <b>{fieldToUpdate.newValue}</b>
                    </p>
                )
            };
        return {
            title: "¿Deseas guardar el cambio?",
            contentComponent: (
                <p className="paragraph">
                    Recuerda que podrás visualizar los cambios en la página principal.
                </p>
            )
        };
    }
    //#endregion
    return (
        <>
        <Container>
            <CustomButton 
                variant="secondary"
                text="Cancelar"
                width="135px"
                size="medium"
                onClick={closeForm}/>
            <CustomButton 
                text={isCreate ? "Asignar" : "Guardar"}
                width="135px"
                size="medium"
                onClick={openDialogSaveChanges}
                disabled={!areThereChanges()}/>
        </Container>
        <DialogSearchCampus 
            show={showDialogSearchCampus}
            toggleShow={toggleShowDialogSearchCampus}
            changeCampus={changeCampusForRoleAssignment}
            roleName={form.value.role.name}
            campusList={campusList}/>
        <DialogAlertAction
            minWidth="560px"
            widthContent={"90%"}
            spacingContainer="16px"
            variant="secondary"
            show={dialogShowSaveChanges.value}
            toggleShow={dialogShowSaveChanges.toggle}
            {...getDialogAlertActionProps()}>
            <CustomButton
                variant="secondary"
                size="medium"
                text="No, cancelar"
                width="110px"
                onClick={() => dialogShowSaveChanges.set(false)}/>
            <CustomButton
                size="medium"
                text={isCreate ? "Sí, asignar" : "Sí, guardar"}
                width="110px"
                onClick={doAssignRoleOrUpdateUser}/>
        </DialogAlertAction>
        </>
    );
}

export default Footer;